module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch1-6"
    }
  }, [_c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/img13.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Silver Street, one of the main thoroughfares in Frenchville, destroyed by the French raid of 1377. Today called Newtown, it is a bird sanctuary and nature trail. ")]), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("Carol Trow")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23fe3276","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/13_ch16.vue
// module id = 90
// module chunks = 0